import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { Box, Typography } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import copy from "copy-to-clipboard";
import { useState } from "react";

import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarChildren,
  setSnackbarDescription,
} from "../../../redux/features/snackbarSlice";
import CustomButton from "../CustomButton";

const CustomSnackbar = () => {
  const dispatch = useAppDispatch();
  const { openSnackbar, snackbarErrorStatus, snackbarDescription, children } =
    useAppSelector((state) => state.snackbar);
  const [acceptCopy, setAcceptCopy] = useState(false);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setOpenSnackbar(false));
  };
  const handleCopyText = () => {
    if (!acceptCopy) {
      snackbarDescription && copy(snackbarDescription);
      setAcceptCopy(true);
      const timer = setTimeout(() => {
        dispatch(setOpenSnackbar(false));
        // dispatch(setSnackbarChildren(undefined));
        setAcceptCopy(false);
      }, 1500);
      return () => clearTimeout(timer);
    }
  };

  return (
    <Snackbar
      sx={{
        left: "50% !IMPORTANT",
        // right: "auto !IMPORTANT",
        bottom: "0px !IMPORTANT",
        maxWidth: "450px",
        width: "100%",
        zIndex: "80000",
        transform: "translateX(-50%)",
      }}
      open={openSnackbar}
      autoHideDuration={6000}
      onClose={handleClose}
      dir="ltr"
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
          mb: "66px",
          pr: "12px",
          pl: "12px",
        }}
      >
        <Box
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 15,
            top: 5,
            padding: "5px",
            cursor: "pointer",
          }}
        >
          <CloseRoundedIcon sx={{ color: "error.main" }} />
        </Box>

        <Box
          sx={{
            height: "auto",
            backgroundColor: "bgColor.white",
            direction: "rtl",
            borderRadius: "15px",
            width: "100%",
            py: "12px",
            px: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            boxShadow: "0px 4px 25px 0px rgba(0, 0, 0, 0.25)",
            border: "1px solid",
            borderColor: "error.main",
          }}
        >
          <Box sx={{ display: "flex", direction: "rtl", alignItems: "center" }}>
            <InfoRoundedIcon sx={{ color: "error.main", fontSize: "30px" }} />
            <Typography
              sx={{ mr: "12px", fontSize: "18px", color: "error.main" }}
            >
              خطای شماره {snackbarErrorStatus}
            </Typography>
          </Box>
          <Typography
            sx={{ mt: "8px", fontSize: "13px", color: "darkStatic.main" }}
          >
            {snackbarDescription}
          </Typography>
          {children ? (
            children
          ) : (
            <CustomButton
              onClick={handleCopyText}
              title={acceptCopy ? "کپی شد" : "کپی متن خطا"}
              bgColor={acceptCopy ? "success.main" : "primary.main"}
              textColor={"#fff"}
              fSize="13px"
              justifyContent="center"
              border="1px solid"
              borderColor={acceptCopy ? "success.main" : "primary.dark"}
              mt="12px"
              icon1={<FileCopyRoundedIcon />}
              width="100%"
              height="40px"
            />
          )}
        </Box>
      </Box>
    </Snackbar>
  );
};
export default CustomSnackbar;
